export function createNode(html: string): HTMLElement {
	let element = document.createElement('div') as HTMLElement;
	element.innerHTML = html;
	element = element.firstElementChild as HTMLElement;
	return element;
}
